import _ from "lodash";
import { de_de } from "./languages/de";
import { en_us } from "./languages/en";
import { LanguageTemplate } from "./template";

export enum Lang {
  DE_DE = "de_de",
  EN_US = "en_us",
}

export type LangSetting = { lang: Lang };
export const LanguageSetting_Key = "language-state";
export const LanguageDefault = Lang.DE_DE;

export const Languages: { [key in Lang]: LanguageTemplate } = {
  de_de,
  en_us,
};

export const getUserLanguage = () => {
  let item = localStorage.getItem(LanguageSetting_Key);
  if (item) return (JSON.parse(item) as LangSetting).lang;
  else return LanguageDefault;
};

export const UserLanguage = () => Languages[getUserLanguage()];

export const resolve_lang = (key: string, input?: any) =>
  _.get(input || UserLanguage(), key, key);
